import {
    formatDueCountdown,
    MOMENT_STATUS_LABELS,
    MOMENT_STATUS_MARKS,
} from '../../helpers/measurementSignals/describeSignal'

// AI-CONTEXT: See docs/features/meetmoment-signalering.md

/**
 * Eén meetmoment van één deelnemer of huishouden, als vakje in de matrix van
 * de kaart 'Aankomende meetmomenten'.
 *
 * Groen betekent dat er een antwoord binnen is, rood dat het er niet is. Twee
 * andere toestanden mogen daar níét in opgaan: 'niet meer mogelijk' (de
 * nulmeting van iemand die al meedraaide) is geen achterstand, en 'niet te
 * zeggen' (het antwoord kan tussen de naamloze antwoorden zitten) is geen
 * bewering. Die krijgen hun eigen, duidelijk afwijkende toon.
 *
 * De kleur draagt het verschil nooit alleen: er staat een teken in het vakje
 * en de volledige tekst staat in `title`.
 *
 * De aftelling staat alleen bij het EERSTVOLGENDE openstaande meetmoment. Voor
 * de metingen daarna is er geen datum af te leiden, en een verzonnen datum is
 * erger dan geen datum.
 *
 * @param {object} props
 * @param {{ID: string, Title?: string, status: 'filled'|'missing'|'missed'|'unknown'}|null} [props.moment]
 *   Het meetmoment op deze positie; `null` als dit onderzoek er minder heeft
 * @param {boolean} [props.isNext] - Of dit het eerstvolgende openstaande meetmoment is
 * @param {number|null} [props.dueDays] - Over hoeveel dagen het de deur uit moet; negatief is te laat
 */
const UpcomingMomentCell = ({ moment, isNext = false, dueDays = null }) => {
    if (!moment) return null

    const label = MOMENT_STATUS_LABELS[moment.status] || MOMENT_STATUS_LABELS.unknown

    return (
        <span className='moment-matrix-cell'>
            <span
                className={[
                    'moment-matrix-dot',
                    `moment-matrix-dot--${moment.status}`,
                    isNext ? 'moment-matrix-dot--next' : '',
                ].filter(Boolean).join(' ')}
                title={`${moment.Title || 'Meetmoment'}: ${label}`}
            >
                {MOMENT_STATUS_MARKS[moment.status] || MOMENT_STATUS_MARKS.unknown}
            </span>
            {isNext && (
                <span className='measurement-signal-note'>{formatDueCountdown(dueDays)}</span>
            )}
        </span>
    )
}

export default UpcomingMomentCell
